export const ANIMAL_SHIPPING_POLICY_TYPES = Object.freeze({
    FREE: 'free',
    CONDITIONAL: 'conditional',
})

export const DEFAULT_ANIMAL_SHIPPING_POLICY = Object.freeze({
    shippingPolicyType: ANIMAL_SHIPPING_POLICY_TYPES.CONDITIONAL,
    shippingPrice: 3500,
    freeShippingThreshold: 29800,
})

export const DEFAULT_NEW_ANIMAL_SHIPPING_POLICY = Object.freeze({
    shippingPolicyType: ANIMAL_SHIPPING_POLICY_TYPES.FREE,
    shippingPrice: 0,
    freeShippingThreshold: null,
})

const hasValue = (value) => value !== undefined && value !== null && value !== ''

export const normalizeAnimalShippingPolicy = (value = {}) => {
    const source = value.shippingPolicy || value
    const policyType = Object.values(ANIMAL_SHIPPING_POLICY_TYPES).includes(source.policyType)
        ? source.policyType
        : (Object.values(ANIMAL_SHIPPING_POLICY_TYPES).includes(source.shippingPolicyType)
            ? source.shippingPolicyType
            : DEFAULT_ANIMAL_SHIPPING_POLICY.shippingPolicyType)

    return {
        shippingPolicyType: policyType,
        shippingPrice: policyType === ANIMAL_SHIPPING_POLICY_TYPES.FREE
            ? 0
            : hasValue(source.shippingPrice)
            ? Number(source.shippingPrice)
            : DEFAULT_ANIMAL_SHIPPING_POLICY.shippingPrice,
        freeShippingThreshold: policyType === ANIMAL_SHIPPING_POLICY_TYPES.FREE
            ? null
            : DEFAULT_ANIMAL_SHIPPING_POLICY.freeShippingThreshold,
    }
}

export const changeAnimalShippingPolicyType = (value, shippingPolicyType) => ({
    ...value,
    shippingPolicyType,
    shippingPrice: shippingPolicyType === ANIMAL_SHIPPING_POLICY_TYPES.FREE
        ? 0
        : (!hasValue(value.shippingPrice) || Number(value.shippingPrice) === 0)
            ? DEFAULT_ANIMAL_SHIPPING_POLICY.shippingPrice
            : value.shippingPrice,
    freeShippingThreshold: shippingPolicyType === ANIMAL_SHIPPING_POLICY_TYPES.CONDITIONAL
        ? DEFAULT_ANIMAL_SHIPPING_POLICY.freeShippingThreshold
        : null,
})

const isNonNegativeInteger = (value) => (
    hasValue(value) && Number.isSafeInteger(Number(value)) && Number(value) >= 0
)

const isPositiveInteger = (value) => (
    hasValue(value) && Number.isSafeInteger(Number(value)) && Number(value) >= 1
)

export const validateAnimalShippingPolicy = (value = {}) => {
    if (!Object.values(ANIMAL_SHIPPING_POLICY_TYPES).includes(value.shippingPolicyType)) {
        return '배송 정책을 선택해주세요.'
    }

    if (
        value.shippingPolicyType === ANIMAL_SHIPPING_POLICY_TYPES.CONDITIONAL
        && !isPositiveInteger(value.shippingPrice)
    ) {
        return '조건부 무료배송의 배송비는 1원 이상의 정수로 입력해주세요.'
    }

    if (!isNonNegativeInteger(value.shippingPrice)) {
        return '배송비는 0원 이상의 정수로 입력해주세요.'
    }

    return null
}
